<template>
  <div
    style="
      width: 100%;
      height: calc(100vh - 70px);

      box-sizing: border-box;
      background-color: #fff;
    "
  >
    <!-- <el-card
      style="width: 100%; height: 100%"
      :body-style="{
        padding: '0px',
      }"
    > -->
    <!-- <el-tabs v-model="activeName" type="card" @tab-click="handleClick" size="mini">
        <el-tab-pane label="设备信息" name="1"> </el-tab-pane>
        <el-tab-pane label="设备资料清单" name="2"> </el-tab-pane>
        <el-tab-pane label="配件清单" name="3"> </el-tab-pane>
      </el-tabs> -->
    <!-- 
    <Spare ref="Spare" v-if="activeName === '3'"></Spare>
    <ScheduleDocument
      ref="ScheduleDocument"
      v-if="activeName === '2'"
    ></ScheduleDocument> -->
    <Schedule
      ref="Schedule"
      v-if="activeName === '1'"
      :treeShow="true"
    ></Schedule>
    <!-- </el-card> -->
  </div>
</template>
<script>
// import Spare from '@/views/Project/Page/ProjectAudit/Spare'
// import ScheduleDocument from '@/views/Project/Page/ProjectAudit/ScheduleDocument'
import Schedule from '@/views/Project/Page/ProjectAudit/Schedule'

export default {
  data() {
    return {
      activeName: '1',
      backName: '',
      title: '',
    }
  },
  props: {},
  components: {
    Schedule,
    // Spare,
    // ScheduleDocument,
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
      // this.activeName = tab.name;
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {
    $route: {
      handler(n, o) {
        console.log(n, 'rorrorororo')
        this.activeName = '1'
        this.title = '设备信息'
        this.backName = window.localStorage.getItem('ProjectName') || ''
      },
      deep: true,
      immediate: true,
    },
    activeName(a) {
      if (a === '1') {
        this.title = '设备信息'
      } else if (a === '2') {
        this.title = '设备资料清单'
      } else if (a === '3') {
        this.title = '配件清单'
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-tabs__header {
  margin: 0;
}
</style>
